module.exports = __webpack_public_path__ + "static/media/homemade-01.51e239c7.webm";